var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    fill: "white",
    stroke: "#002857"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.32 6.35C10.32 6.74333 10.2467 7.09 10.1 7.39C9.95333 7.69 9.75333 7.94 9.5 8.14C9.24667 8.34 8.95 8.49333 8.61 8.6C8.27 8.7 7.90667 8.75 7.52 8.75H6.13V11H4.9V4H7.66C8.06667 4 8.43333 4.05667 8.76 4.17C9.09333 4.27667 9.37333 4.43333 9.6 4.64C9.83333 4.84667 10.01 5.09333 10.13 5.38C10.2567 5.66667 10.32 5.99 10.32 6.35ZM9.07 6.38C9.07 5.96 8.93333 5.64667 8.66 5.44C8.38667 5.22667 8.02 5.12 7.56 5.12H6.13V7.64H7.56C8.02667 7.64 8.39333 7.52667 8.66 7.3C8.93333 7.06667 9.07 6.76 9.07 6.38Z",
    fill: "#002857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPIcon);
export default __webpack_public_path__ + "static/media/p-icon.e8cd3400b0ab387c714dadff6154509c.svg";
export { ForwardRef as ReactComponent };